import React from 'react';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import IconCheck from '@static/images/icon_check.svg';
import { TradeActions } from '@colonist/game-mechanic-validators';
import { TradeResponseStatus } from '@colonist/game-states';
import styles from '../UIGameTradeOffers.module.scss';
import clsx from 'clsx';
import { T } from '@colonist/ui';
import { useGameStore } from '../../../store/GameStoreContext.ts';
export const UIGameTradeOfferAcceptTradeButton = ({ className, tradeValidator, setIsOtherButtonsClicked, disableTooltips })=>{
    const isMyColorSpectator = useGameStore((state)=>state.isMyColorSpectator);
    const myColor = useGameStore((state)=>state.myColor);
    const { sendForceOpenGuideBubble } = useGameStore((state)=>state.gameSendEvent);
    const sendUpdateTradeResponse = useGameStore((state)=>state.gameTradeOffers.sendUpdateTradeResponse);
    const acceptAction = tradeValidator.getAcceptTradeActionStatus(myColor);
    const myResponseStatus = tradeValidator.getPlayerResponseState(myColor);
    const highlighted = (myResponseStatus === null || myResponseStatus === void 0 ? void 0 : myResponseStatus.responseStatus) == TradeResponseStatus.Accepted;
    const isHidden = !acceptAction.displayActionButton;
    const tooltipText = 'strings:game.tooltips.acceptTrade';
    const helperText = acceptAction.errorMessageIfCantTakeAction;
    const isEnabled = acceptAction.canTakeAction && !isMyColorSpectator;
    const isEmbargoed = (myResponseStatus === null || myResponseStatus === void 0 ? void 0 : myResponseStatus.responseStatus) == TradeResponseStatus.Embargoed;
    const handleClick = ()=>{
        const isRejectForcedBeginnerMode = tradeValidator.state.forcedResponse == TradeResponseStatus.Rejected;
        if (isRejectForcedBeginnerMode) {
            sendForceOpenGuideBubble();
            return;
        }
        const acceptTrade = {
            id: tradeValidator.state.id,
            response: TradeActions.Accept
        };
        sendUpdateTradeResponse(acceptTrade);
        setIsOtherButtonsClicked(true);
    };
    if (isHidden) return null;
    return /*#__PURE__*/ React.createElement(UIGameActionButton, {
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: tooltipText
        }),
        centerTextTooltip: true,
        className: clsx(styles.tradeButton, className),
        iconPath: IconCheck,
        onClick: handleClick,
        buttonType: "trade",
        tooltipPosition: "bottom",
        helperText: helperText,
        disabled: !isEnabled,
        isEmbargoed: isEmbargoed,
        highlight: highlighted,
        tooltipDisabled: disableTooltips
    });
};
